import http from '@/plugins/axios';
export default {
  getEmpresa: function getEmpresa(idEmpresa) {
    return http.apiCore.get("/v1/empresa/".concat(idEmpresa));
  },
  redirecionarAreaLogada: function redirecionarAreaLogada(identificador, params) {
    return http.apiCore.get("/v1/empresa/redirecionar/".concat(identificador), {
      params: params
    });
  }
};